import { URL } from '../../../config'
import { postRequest } from '../../../utils/functions/httpRequest'

export default function (userRequestId, reason, token) 
{
  const denyRequestURL =  `${URL.user}/${userRequestId}/denyaccess/${reason}` 
  const denyRequest =
  {
  }
  return postRequest(denyRequestURL,denyRequest,token)
}



// WEBPACK FOOTER //
// ./src/components/userSearchResults/api/denyRequest.js